import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { formatAlertSummary } from './hooks/utils';
import useSetAIAlertExport from '@components/alert-panel/AIAlert/hooks/useSetAIAlertExport';
import { usePageTitle } from '@src/hooks';
import { aiAlertsDimensionMappingSelector } from '@src/store/common/selectors';
import { dimensionsListSelectorKeyValue } from '@src/store/common/dimensionList/selectors';
import ExpandedAIAlertInfo from './AIAlertExpandedInfo';
import { useDrilldownMeta } from '@src/hooks/common/useDrilldownMeta';

function AlertInfo({ alert, setIsExpand, isExpand }) {
  const dimensionListObject = useSelector(dimensionsListSelectorKeyValue);
  const dimensionMapping = useSelector(aiAlertsDimensionMappingSelector);
  const { flowId } = useDrilldownMeta();
  useSetAIAlertExport();

  const info = useMemo(() => {
    if (alert) {
      return formatAlertSummary(alert, flowId, null, dimensionListObject, dimensionMapping);
    }
    return {};
  }, [alert, dimensionListObject, dimensionMapping]);

  usePageTitle({ text: info ? `Alert - ${info.rootCause}` : 'Alert...' });

  return (
    <ExpandedAIAlertInfo
      info={info}
      isExpand={isExpand}
      setIsExpand={setIsExpand}
      isFlow={!!flowId}
    />
  );
}

export default AlertInfo;
